export default __webpack_public_path__ + "static/media/27.51844c00.jpg";